<template>
  <div>
    <div v-if="doses != null">
      <b-table-lite responsive :items="doses" :fields="fields">
        <template #cell(vacina_nome_tecnico)="data">
          <b-card-text class="font-weight-bold mb-25">
            {{ data.item.vacina_nome_tecnico }} <br />
          </b-card-text>
          <b-card-text class="text-nowrap">
            {{ data.item.nome_categoria }}
          </b-card-text>
        </template>

        <template #cell(id_incentivo)="data">
          Lote {{ (data.item.id_incentivo == 1 ? lotePadrao : lotePromocional) }}
        </template>

        <template #cell(custo_unitario)="data">
          {{ formatCurrency(data.item.custo_unitario) }}
        </template>

        <template #cell(valor)="data">
          {{ formatCurrency(data.item.valor) }}
        </template>
      </b-table-lite>
    </div>

    <b-card-body class="order-details-padding pb-0 mb-2">
      <div class="order-totals">
        <p>Quantidade total: </p>
        <p class="order-totals-value mr-2">
          {{ getSumTotalQtd }} doses
        </p>

        <p>Total: </p>
        <p class="order-totals-value">
          {{ getTotals }}
        </p>
      </div>
    </b-card-body>
  </div>
</template>

<script>
import { BTableLite, BCardBody, BCardText } from 'bootstrap-vue'

export default {
    components: {
    BTableLite,
    BCardBody,
    BCardText
  },
  props: {
    doses: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      lotePadrao: '2',
      lotePromocional: '1',
      fields: [
        { key: 'vacina_nome_tecnico', label: 'Vacina' },
        { key: 'id_incentivo', label: 'Lote' },
        { key: 'custo_unitario', label: 'Custo Unitário' },
        { key: "qtd_distribuida", label: "Qtd de Doses", class: "text-center" },
        { key: 'valor', label: 'Valor' }
      ]
    }
  },
  computed: {
    getSumTotalQtd() {
      if (!this.doses) return 0
      return this.doses.reduce((sum, item) => sum + Number(item.qtd_distribuida), 0)
    },
    getTotals() {
      if (!this.doses) return 0
      return this.formatCurrency(this.doses.reduce((sum, item) => sum + Number(item.valor), 0))
    }
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "./../style.scss";

.order-details-padding {
  padding: 1rem;
}

.order-totals {
  display: flex;
  align-items: center;
}

.order-totals p {
  margin-bottom: 0;
}

.order-totals-value {
  font-weight: bold;
  margin-right: 1rem;
}
</style>
